// src\core\config\theme-config.ts
type SiteConfig = {
  siteName: string;
  siteTitle: string;
  theme: string;
  fallbackTheme: string;
  defaultLayout: string;
};

const siteConfig: SiteConfig = {
  siteName: process.env.NEXT_PUBLIC_SITE_NAME || 'xoos-site',
  siteTitle: process.env.NEXT_PUBLIC_SITE_TITLE || 'Xoos website Title',
  theme: process.env.NEXT_PUBLIC_THEME || 'default',
  fallbackTheme: process.env.NEXT_PUBLIC_FALLBACK_THEME || 'default',
  defaultLayout: process.env.NEXT_PUBLIC_DEFAULT_LAYOUT || 'default',
};

export const THEMES = {
  default: 'default',
} as const;

export type ThemeName = keyof typeof THEMES;

export function getCurrentTheme(): string {
  return siteConfig.theme;
}

export function getFallbackTheme(): string {
  return siteConfig.fallbackTheme;
}

export function getSiteConfig() {
  return siteConfig;
}

export function getDefaultLayout(): string {
  return siteConfig.defaultLayout;
}

export default siteConfig;
